/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description <p>Возможные значения:</p>\n<ul>\n<li><b>1 - Donate</b>: Пожертвование</li>\n</ul>\n
 */
export const donationTypeEnumSchema = z.literal(1).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Donate</b>: Пожертвование</li>\n</ul>\n")